import { Link } from 'react-router-dom'
import { Twitter, Linkedin, Youtube, ArrowRight } from 'lucide-react'
import { useState } from 'react'

const productLinks = [
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/features', label: 'Features' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/faq', label: 'FAQ' },
]

const companyLinks = [
    { path: '/about', label: 'About' },
    { path: '/blog', label: 'Blog' },
    { path: '#', label: 'Careers' },
    { path: '#', label: 'Contact' },
]

const legalLinks = [
    { path: '#', label: 'Privacy Policy' },
    { path: '#', label: 'Terms of Service' },
    { path: '#', label: 'GDPR Compliance' },
]

export default function Footer() {
    const [email, setEmail] = useState('')

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        // Handle newsletter signup
        console.log('Newsletter signup:', email)
        setEmail('')
    }

    return (
        <footer className="w-full glass-section border-t border-primary-base/10 py-16 px-8 lg:px-20">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    {/* Product Column */}
                    <div className="flex flex-col gap-4">
                        <h3 className="text-lg font-semibold text-primary-color mb-2">Product</h3>
                        {productLinks.map((link) => (
                            <Link
                                key={link.label}
                                to={link.path}
                                className="text-base font-normal text-secondary-color hover:text-primary-base transition-colors"
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>

                    {/* Company Column */}
                    <div className="flex flex-col gap-4">
                        <h3 className="text-lg font-semibold text-primary-color mb-2">Company</h3>
                        {companyLinks.map((link) => (
                            <Link
                                key={link.label}
                                to={link.path}
                                className="text-base font-normal text-secondary-color hover:text-primary-base transition-colors"
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>

                    {/* Legal Column */}
                    <div className="flex flex-col gap-4">
                        <h3 className="text-lg font-semibold text-primary-color mb-2">Legal</h3>
                        {legalLinks.map((link) => (
                            <Link
                                key={link.label}
                                to={link.path}
                                className="text-base font-normal text-secondary-color hover:text-primary-base transition-colors"
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>

                    {/* Connect Column */}
                    <div className="flex flex-col gap-4">
                        <h3 className="text-lg font-semibold text-primary-color mb-2">Connect</h3>

                        {/* Social Icons */}
                        <div className="flex items-center gap-4">
                            <a href="#" className="hover:opacity-70 transition-opacity">
                                <Twitter className="w-5 h-5 text-secondary-color" />
                            </a>
                            <a href="#" className="hover:opacity-70 transition-opacity">
                                <Linkedin className="w-5 h-5 text-secondary-color" />
                            </a>
                            <a href="#" className="hover:opacity-70 transition-opacity">
                                <Youtube className="w-5 h-5 text-secondary-color" />
                            </a>
                        </div>

                        {/* Newsletter Signup */}
                        <div className="flex flex-col gap-2 mt-2">
                            <p className="text-sm font-normal text-secondary-color">Email signup for updates</p>
                            <form onSubmit={handleSubmit} className="flex items-center gap-2">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter email"
                                    className="flex-1 px-4 py-2 text-sm bg-white/50 backdrop-blur-md border border-primary-base/15 rounded-full focus:outline-none focus:border-primary-base/25 transition-colors"
                                />
                                <button
                                    type="submit"
                                    className="btn-primary p-2 rounded-full"
                                >
                                    <ArrowRight className="w-4 h-4" />
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="mt-12 pt-12 border-t border-primary-base/10">
                    <p className="text-sm text-center font-normal text-tertiary-color">
                        © 2026 Way2Will. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}
